'use client'

import React, { useEffect, useState } from 'react';
import { CollectionStatementProps } from './types';
import Markdown from '@/components/atoms/markdown';
import Typography from '@/components/atoms/typography';
import { log } from 'console';

const CollectionStatement = ({ CollectionStatementdata }: CollectionStatementProps) => {
  const title = CollectionStatementdata?.sections?.find((section) => section?.section_with_heading_description)?.section_with_heading_description?.title ?? '';
  const summary = CollectionStatementdata?.sections?.find((section) => section?.section_with_heading_description)?.section_with_heading_description?.description ?? '';

    const [pageLoaded, setPageLoaded] = useState(false);
  
    useEffect(() => {
      const handleLoad = () => {
        setPageLoaded(true);
      };
  
      if (document.readyState === 'complete') {
        // Page already loaded (e.g., fast navigation)
        setPageLoaded(true);
      } else {
        // Wait for full load
        window.addEventListener('load', handleLoad);
      }
  
      return () => {
        window.removeEventListener('load', handleLoad);
      };
    }, []);

  return (
    <div className={`flex ${!pageLoaded && "mt-[181px]"} justify-center collection-statement `}>
      <div className="flex flex-col items-center px-[36px] lg:px-[90px] py-[18px]">
        {title && (
          <Typography
            fontSize={24}
            className="pb-3 text-[24px] lg:text-[48px] !font-medium  leading-10 text-gray-700 text-center relative"
          >
            {title}
          </Typography>
        )}

        <Markdown className='whitespace-pre-wrap text-primary-black [&>p]:my-3 [&>ul]:list-disc [&>ul]:ml-20 [&>ul>li]:my-3 [&>ul>li>p>a]:!text-blue [&>p>a]:!text-[#0000FF] [&>a]:!text-[#0000FF] text-14 md:text-16 2xl:text-18' >{summary}</Markdown>
      </div>
    </div>
  );
};

export default CollectionStatement;
